import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import GLOBALS from "../global";
import CONSTANT from "../constants/Constant";
import DirectToConsumerService from "../services/DirectToConsumerService";
import GLOBAL from "../global";
import { useTenantFeatures } from "../features/tenantFeatures/useTenantFeature";

const PAGE_TITLES = {
    '/': 'Sign In',
    '/sign-in': 'Sign In',
    '/sign-up': 'Sign Up',
    '/dashboard': 'Dashboard',
    '/my-assessments': 'My Assessments',
    '/my-exercises': 'My Exercises',
    '/my-calendar': 'My Calendar',
    '/my-reports': 'My Reports',
    '/my-subscription': 'My Subscription',
    '/assessment': 'Assessment',
    '/edit-assessment': 'Edit Assessment',
    '/edit-assessment-old': 'Edit Assessment',
    '/show-all-questions': 'Assessment Questions',
    '/cards': 'Payment Methods',
    '/add-card': 'Add Payment Method',
    '/forgot': 'Forgot Password',
    '/delete-account': 'Delete Account',
    '/package-details': 'Package Details',
    '/plans': 'Plans',
    '/packages': 'Packages',
    '/unauthorized': 'Unauthorized Access',
    '/callback': 'Processing',
    '/sncLogin': 'Login',
    '/onboarding': 'Onboarding',
    '/new-registration': 'Pre-Registration'
};

const usePageTitle = (customTitle, pathname) => {
    const location = useLocation();
    const { isSpinealignEnabled } = useTenantFeatures();

    useEffect(() => {
        let isMounted = true; // prevent state updates after unmount

        const updateTitle = async () => {
            let pageName = customTitle;

            if (!pageName && pathname) {
                const cleanPath = pathname.replace(process.env.REACT_APP_ROUTE_BASE_PATH || '', '') || '/';

                if (cleanPath.startsWith('/my-assessments/')) {
                    pageName = 'My Assessments';
                } else if (cleanPath.startsWith('/my-exercises/')) {
                    pageName = 'My Exercises';
                } else if (cleanPath.startsWith('/edit-assessment-old/')) {
                    pageName = 'Edit Assessment';
                } else if (cleanPath.startsWith('/edit-assessment/')) {
                    pageName = 'Edit Assessment';
                } else if (cleanPath.startsWith('/show-all-questions/')) {
                    pageName = 'Assessment Questions';
                } else {
                    pageName = PAGE_TITLES[cleanPath] || 'Dashboard';
                }
            }

            const tenantName = (GLOBALS.TENANT?.charAt(0).toUpperCase() + GLOBALS.TENANT?.slice(1) || 'MyPainLog').toUpperCase();
            const appName = isSpinealignEnabled ? 'MyBackHub' : 'MyPainLog';
            let finalTitle = `${tenantName} | ${appName} | ${pageName}`;

            if (pathname.includes('/package-details')) {
                const query = new URLSearchParams(location?.search);
                const packageId = query.get(CONSTANT.QUERY_PARAM.PACKAGE_ID) || '';

                if (packageId) {
                    try {
                        const packageData = await DirectToConsumerService.getPackageById({
                            GId: packageId,
                            Tenant: GLOBALS.TENANT
                        });

                        if (isMounted && packageData?.success) {
                            const packageTitle = packageData?.data?.Title;
                            finalTitle = `${tenantName} | ${appName} | ${packageId} | ${packageTitle}`;
                        }
                    } catch (err) {
                        console.error("Failed to fetch package data:", err);
                        finalTitle = `${tenantName} | ${appName} | ${pageName}`;
                    }
                }
            }

            console.log(finalTitle)

            if (isMounted) {
                document.title = finalTitle || 'Efficient Musculoskeletal Management Assistant';
            }
        };

        updateTitle();

        return () => {
            isMounted = false; // cleanup
        };
    }, [customTitle, pathname, location?.search, isSpinealignEnabled]);
};

export default usePageTitle;
